import axios from 'axios';
import SetupBackEnd from './config/config.js';

const url = axios.create({
    baseURL: 'https://api-publica.speedio.com.br/buscarcnpj?cnpj='
});

function searchCNPJ(cnpj) {
    return url.get(cnpj);
}

function searchCNPJRapidAPI(cnpj) {
  return SetupBackEnd.post('/search-cnpj', cnpj);
}

const CNPJServices = {
    searchCNPJ,
    searchCNPJRapidAPI
}

export default CNPJServices;
